const SupportLink: React.FC = () => (
  <a href="https://wa.me/+5511987826794" target="_blank" rel="noopener">
    WhatsApp: (11) 98782-6794
  </a>
);

export const SuccessPage: React.FC = () => (
  <div className="page">
    <div className="page__inner">
      <div className="logo-text">Vammo</div>

      <div className="success-icon">✓</div>

      <h1 className="title">
        <span className="accent">Tudo certo.</span>
        <br />
        Sua migração foi registrada.
      </h1>
      <p className="subtitle">
        A mudança será aplicada automaticamente na sua próxima cobrança. Você
        não precisa fazer mais nada.
      </p>

      <div className="success-box">
        <h3>O que acontece agora</h3>
        <ul>
          <li>Sua cobrança atual em aberto segue com o preço e formato antigos.</li>
          <li>
            No início do próximo ciclo, você passa automaticamente para o novo
            plano.
          </li>
          <li>
            Você receberá uma notificação no app e um e-mail quando a mudança
            ficar ativa.
          </li>
        </ul>
      </div>

      <p className="form__help mt-5">
        Dúvidas? Fale com o suporte no <SupportLink />.
      </p>
    </div>
  </div>
);

export const IneligiblePage: React.FC = () => (
  <div className="page">
    <div className="page__inner">
      <div className="logo-text">Vammo</div>

      <span className="eyebrow">Atendimento necessário</span>
      <h1 className="title">
        Sua migração precisa de{" "}
        <span className="accent">atendimento dedicado</span>.
      </h1>

      <div className="info-box">
        <p>
          Sua conta está no plano <strong>Comfort Mensal</strong>, que não está
          disponível para migração automática por este canal.
        </p>
        <p>
          Para alterar a periodicidade ou o preço do seu plano, fale direto com
          nosso atendimento:
        </p>
        <p>
          <SupportLink />
        </p>
      </div>
    </div>
  </div>
);

export const ExpiredPage: React.FC = () => (
  <div className="page">
    <div className="page__inner">
      <div className="logo-text">Vammo</div>

      <span className="eyebrow">Campanha encerrada</span>
      <h1 className="title">
        Esta migração online <span className="accent">foi encerrada</span>.
      </h1>

      <div className="info-box">
        <p>A mudança de preço não está mais disponível por aqui.</p>
        <p>Para modificar sua assinatura, fale com nosso atendimento:</p>
        <p>
          <SupportLink />
        </p>
      </div>
    </div>
  </div>
);

export const NotRegisteredPage: React.FC<{ onRetry: () => void }> = ({
  onRetry,
}) => (
  <div className="page">
    <div className="page__inner">
      <div className="logo-text">Vammo</div>

      <span className="eyebrow">Atendimento necessário</span>
      <h1 className="title">
        Não encontramos sua <span className="accent">conta</span>.
      </h1>

      <div className="info-box">
        <p>
          O número informado não está vinculado a uma conta Vammo ativa
          elegível para migração online.
        </p>
        <p>Se você acha que isso é um engano, fale com nosso suporte:</p>
        <p>
          <SupportLink />
        </p>
      </div>

      <div className="comparison-cta">
        <button type="button" className="btn btn--ghost" onClick={onRetry}>
          Tentar com outro número
        </button>
      </div>
    </div>
  </div>
);
